import { Container } from '@chakra-ui/layout';
import { useColorModeValue } from '@chakra-ui/react';
import Content from './Content/Content';
import Sidebar from './Sidebar/Sidebar';

export default function Main({ userData, updateUser }) {
  const isEditable = userData.editable; // Get the isEditable value from userData


  const bgColor = useColorModeValue('black', 'white');
  const textColor = useColorModeValue('black', 'white');
  const headingColor = useColorModeValue('black', 'white');

  if (!userData) {
    return <p>Loading...</p>;  // Handle the case where userData is not yet available
  }

  return (
    <Container display={{ base: 'block', md: 'flex' }} maxW="container.xl">
      <Sidebar userData={userData} isEditable={isEditable}/>
      <Content userData={userData} onSave={updateUser} isEditable={isEditable} /> {/* Pass isEditable */}
    </Container>
  );
}
